import { ITOClient, } from "./ITOClient";
import { AddOrderLabelCommand, } from "./commands/AddOrderLabelCommand";
import { AddSubLineItemCommand, } from "./commands/AddSubLineItemCommand";
import { BulkProcessSubLinesCommand, } from "./commands/BulkProcessSubLinesCommand";
import { CutTicketCommand, } from "./commands/CutTicketCommand";
import { DeleteCommentCommand, } from "./commands/DeleteCommentCommand";
import { DeleteItemAttachmentCommand, } from "./commands/DeleteItemAttachmentCommand";
import { DeleteNoteCommand, } from "./commands/DeleteNoteCommand";
import { DeleteSubLineItemCommand, } from "./commands/DeleteSubLineItemCommand";
import { DownloadOrdersCommand, } from "./commands/DownloadOrdersCommand";
import { GetBulkDownloadHistoryCommand, } from "./commands/GetBulkDownloadHistoryCommand";
import { GetCommentsCommand, } from "./commands/GetCommentsCommand";
import { GetFilePresignedUrlCommand, } from "./commands/GetFilePresignedUrlCommand";
import { GetFilesCommand, } from "./commands/GetFilesCommand";
import { GetItemAttachmentCommand, } from "./commands/GetItemAttachmentCommand";
import { GetItemAttachmentsCommand, } from "./commands/GetItemAttachmentsCommand";
import { GetNotesCommand, } from "./commands/GetNotesCommand";
import { GetOrderCommand, } from "./commands/GetOrderCommand";
import { GetOrderItemsCommand, } from "./commands/GetOrderItemsCommand";
import { GetOrderItemsDownloadCommand, } from "./commands/GetOrderItemsDownloadCommand";
import { GetOrders_AllCommand, } from "./commands/GetOrders_AllCommand";
import { GetOrders_DirectsCommand, } from "./commands/GetOrders_DirectsCommand";
import { GetOrders_MyCommand, } from "./commands/GetOrders_MyCommand";
import { GetTicketCommand, } from "./commands/GetTicketCommand";
import { GetTickets_AllCommand, } from "./commands/GetTickets_AllCommand";
import { GetTickets_DirectsCommand, } from "./commands/GetTickets_DirectsCommand";
import { GetTickets_MyCommand, } from "./commands/GetTickets_MyCommand";
import { HeadOrders_DirectsCommand, } from "./commands/HeadOrders_DirectsCommand";
import { PatchCommentCommand, } from "./commands/PatchCommentCommand";
import { PatchNoteCommand, } from "./commands/PatchNoteCommand";
import { PostBulkCommand, } from "./commands/PostBulkCommand";
import { PostCommentCommand, } from "./commands/PostCommentCommand";
import { PostItemAttachmentCommand, } from "./commands/PostItemAttachmentCommand";
import { PostLineCommentBulkCommand, } from "./commands/PostLineCommentBulkCommand";
import { PostLineCommentCommand, } from "./commands/PostLineCommentCommand";
import { PostNoteCommand, } from "./commands/PostNoteCommand";
import { ProcureOrderItemsCommand, } from "./commands/ProcureOrderItemsCommand";
import { RecallOrderCommand, } from "./commands/RecallOrderCommand";
import { RecallOrdersCommand, } from "./commands/RecallOrdersCommand";
import { SubmitOrderCommand, } from "./commands/SubmitOrderCommand";
import { UpdateItemDetailsCommand, } from "./commands/UpdateItemDetailsCommand";
import { UpdateOrderStatusBatchCommand, } from "./commands/UpdateOrderStatusBatchCommand";
import { UpdateOrderStatusCommand, } from "./commands/UpdateOrderStatusCommand";
import { UpdateSubLineItemCommand, } from "./commands/UpdateSubLineItemCommand";
import { UpdateTicketStatusCommand, } from "./commands/UpdateTicketStatusCommand";
import { createAggregatedClient } from "@smithy/smithy-client";
const commands = {
    AddOrderLabelCommand,
    AddSubLineItemCommand,
    BulkProcessSubLinesCommand,
    CutTicketCommand,
    DeleteCommentCommand,
    DeleteItemAttachmentCommand,
    DeleteNoteCommand,
    DeleteSubLineItemCommand,
    DownloadOrdersCommand,
    GetBulkDownloadHistoryCommand,
    GetCommentsCommand,
    GetFilePresignedUrlCommand,
    GetFilesCommand,
    GetItemAttachmentCommand,
    GetItemAttachmentsCommand,
    GetNotesCommand,
    GetOrderCommand,
    GetOrderItemsCommand,
    GetOrderItemsDownloadCommand,
    GetOrders_AllCommand,
    GetOrders_DirectsCommand,
    GetOrders_MyCommand,
    GetTicketCommand,
    GetTickets_AllCommand,
    GetTickets_DirectsCommand,
    GetTickets_MyCommand,
    HeadOrders_DirectsCommand,
    PatchCommentCommand,
    PatchNoteCommand,
    PostBulkCommand,
    PostCommentCommand,
    PostItemAttachmentCommand,
    PostLineCommentCommand,
    PostLineCommentBulkCommand,
    PostNoteCommand,
    ProcureOrderItemsCommand,
    RecallOrderCommand,
    RecallOrdersCommand,
    SubmitOrderCommand,
    UpdateItemDetailsCommand,
    UpdateOrderStatusCommand,
    UpdateOrderStatusBatchCommand,
    UpdateSubLineItemCommand,
    UpdateTicketStatusCommand,
};
export class ITO extends ITOClient {
}
createAggregatedClient(commands, ITO);
